module.exports = __webpack_public_path__ + "static/media/400391_02.108c1322.png";